import React from 'react'
import { useTypewriter, Cursor } from "react-simple-typewriter";
import Media from './Media';

const LeftBanner = () => {
  const [text] = useTypewriter({
    words: ["Professional Coder.", "Front End Developer.", "MERN Stack Developer."],
    loop: true,
    typeSpeed: 20,
    deleteSpeed: 10,
    delaySpeed: 2000,
  });
  return (
    <div className="w-full lgl:w-1/2 flex flex-col gap-20" data-aos="fade-up"
    data-aos-easing="ease-out-cubic"
    data-aos-duration="1500">
      <div className="flex flex-col gap-5">
        <h1 className="text-6xl font-bold text-white">
          Hello!<br /> I'm <span className="text-designColor capitalize">Md Jaoadul Islam</span>
        </h1>
        <h2 className="text-4xl font-bold text-white">
          a <span>{text}</span>
          <Cursor
            cursorBlinking="false"
            cursorStyle="|"
            cursorColor="#ff014f"
          />
        </h2>
        <p className="text-base font-bodyFont leading-6 tracking-wide">
          Dedicated developer at heart, I bring a blend of hard work, relentless dedication, and an insatiable appetite for learning to every project I touch. My passion for technology drives me to constantly refine my skills and embrace new challenges, ensuring that I deliver innovative and effective solutions. With a commitment to excellence and a focus on continuous improvement, I am on a quest to transform visions into reality, one line of code at a time. Let's collaborate and create something truly remarkable.
        </p>
      </div>
      {/* Media */}
      <Media />
    </div>
  );
}

export default LeftBanner